import { DatePickerAdapter } from 'components/enhanced/form/adapters/date-time/DatePickerAdapter';
import { AutocompleteAdapter } from 'components/enhanced/form/adapters/selects/AutocompleteAdapter';
import { TextFieldAdapter } from 'components/enhanced/form/adapters/text-inputs/TextFieldAdapter';
import EnhancedForm from 'components/enhanced/form/EnhancedForm';
import { IdentityField } from 'components/enhanced/form/fields/IdentityField';
import { supplierService } from 'features/inventory/suppliers/api/SupplierService';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Option } from 'shared/types/general';

interface InvoiceCreateFormProps {
  onSubmit: any;
}
function InvoiceCreateForm({ onSubmit }: InvoiceCreateFormProps) {
  const { t } = useTranslation();

  const [suppliers, setSuppliers] = useState<Option[]>([]);

  useEffect(() => {
    supplierService.getAllBaseInformation().then((res) => {
      setSuppliers(
        res.map((supplier) => {
          return {
            id: supplier.id,
            code: `${supplier.code} - ${supplier.company_name}`
          };
        })
      );
    });
  }, []);

  return (
    <EnhancedForm
      onSubmit={onSubmit}
      formId="newInvoice"
      hideControls
      autoStyleLayout={true}
      columns={2}>
      <IdentityField
        gridSpan={2}
        name="supplier"
        component={AutocompleteAdapter}
        options={suppliers}
        placeholder={t('global.contract')}
        label={t('global.contract')}
        required
      />
      <IdentityField
        name="ref"
        label={t(`entities.ddt.invoice_ref`)}
        component={TextFieldAdapter}
        required
      />
      <IdentityField name="date" label={t(`global.date`)} component={DatePickerAdapter} />
      <IdentityField
        gridSpan={2}
        name="notes"
        component={TextFieldAdapter}
        placeholder={t('global.notes')}
        label={t('global.notes')}
      />
    </EnhancedForm>
  );
}

export default InvoiceCreateForm;
